import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import WatchIcon from "@mui/icons-material/Watch";
// import CookieIcon from "@mui/icons-material/Cookie";
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import LocationOnIcon from "@mui/icons-material/LocationOn";
import ContactMailIcon from "@mui/icons-material/ContactMail";


import sirrea3 from "./assets/sirrea3.JPG";
import tessa from "./assets/tessa.JPG";
import RachelyP from "./assets/RachelyP.jpg";
import RachelyP3 from "./assets/RachelyP3.JPG";
import shoniah from "./assets/shoniah.JPG";
import shoniahPortrait from "./assets/shoniahPortrait.jpg";
import KarinaStreet from "./assets/karinaStreet.jpg";
import KarinaP2 from "./assets/KarinaP2.JPG";
import ZiannaP3 from "./assets/ZiannaP3.JPG";
import ziannaBoudoir from "./assets/ziannaBoudoir.JPG";
import tessaBoudoir from "./assets/tessaBoudoir.JPG";
import abigale from "./assets/abigaleBoudoir.jpg";
import CassidyMMA from "./assets/CassidyMMA.JPG";

import ZenobiaP2 from "./assets/ZenobiaP2.JPG";


import Britt from  "./assets/Britt.JPG";
import Jasline from  "./assets/jasline.jpg";
import Karla from  "./assets/Karla.JPG";
import Lizz from  "./assets/Liz.JPG";
import GradStu from "./assets/GradStu.JPG";
import cesar from "./assets/cesar.JPG";
import DevonteP from "./assets/DevonteP.JPG";
import jorden from "./assets/jorden.JPG";
import jordenMMA from "./assets/jordenMMA.jpg";
import nacier from "./assets/nacier.JPG";
import caston from "./assets/CastonP.JPG";
import AnthonyPortrait from "./assets/AnthonyPortrait.jpg";
import jerm from "./assets/jerm.jpg";
import raymond from "./assets/raymond.jpg";
import jordan from "./assets/jordan.JPG";



export const navLinks = [
  {
    id: 1,
    text: "Home",
    href: "home",
  },
  {
    id: 2,
    text: "Photoshoots",
    href: "photoshoots",
  },
  {
    id: 3,
    text: "Services",
    href: "services",
  },
  //   {
  //     id: 4,
  //     text: "Blog",
  //     href: "blog",
  //   },
  {
    id: 4,
    text: "Contact",
    href: "contact",
  },
];

export const services = [
  {
    id: 1,
    icon: <AttachMoneyIcon />,
    title: "Prices",
    text: "Studio (Solos): $350",
    text2: "Studio (Duos): $500",
    text3: "Studio (Groups over 3+): $750",
    text4: "Outdoor (Solos): $170",
    text5: "Outdoor (Duos): $340",
    text6: "Outdoor (Groups over 3+): $550",
    text7: "Feel free to contact me for more questions down below."
  },
  {
    id: 2,
    icon: <WatchIcon />,
    title: "Working Hours",
    text: "Monday: 12pm - 9pm",
    text2: "Tuesday: 12pm - 9pm",
    text3: "Wednesday: 12pm - 9pm",
    text4: "Thursday: 1pm - 9pm",
    text5: "Friday: 1pm - 9pm",
    text6: "Saturday: FLEXIBLE",
    text7: "Sunday: UNAVAILABLE"
  },
];

export const requirements = [  
  
  {
    id: 1,
    icon: <AccessTimeIcon />,
    text: "Time Management",
    amount: "Photoshoots are a minimum of 2hrs",
    tab: "PLEASE BE ON TIME!",
  },
  {
    id: 2,
    icon: <LocalAtmIcon />,
    text: "Deposit",
    amount: "50% or Full payment with Zelle",
  },
  // {
  //   id: 3,
  //   icon: <CookieIcon />,
  //   text: "HOLDER",
  //   amount: 0,
  // },

  // {
  //   id: 4,
  //   icon: <CookieIcon />,
  //   text: "HOLDER",
  //   amount: 0,
  // },

];
export const btns = [
  { id: 1, name: "All", value: "all" },
  { id: 2, name: "Portrait", value: "portraits" },
  { id: 3, name: "Street", value: "streets" },
  { id: 4, name: "Lifestyle", value: "lifestyle" },
  { id: 5, name: "Boudoir", value: "boudoir" },
];

export const photoshoots = [
  {
    id: 1,
    image: sirrea3,
    value: "lifestyle",
  },
  {
    id: 2,
    image: tessa,
    value: "lifestyle",
  },
  {
    id: 3,
    image: RachelyP,
    value: "portraits",
  },

  {
    id: 4,
    image: RachelyP3,
    value: "lifestyle",
  },
  {
    id: 5,
    image: shoniah,
    value: "lifestyle",
  },

  {
    id: 6,
    image: shoniahPortrait,
    value: "portraits",
  },
  {
    id: 7,
    image: KarinaStreet,
    value: "streets",
  },
  {
    id: 8,
    image: KarinaP2,
    value: "lifestyle",
  },

  {
    id: 9,
    image: ZiannaP3,
    value: "portraits",
  },

  {
    id: 10,
    image: ziannaBoudoir,
    value: "boudoir",
  },

  {
    id: 11,
    image: tessaBoudoir,
    value: "boudoir",
  },

  {
    id: 12,
    image: abigale,
    value: "boudoir",
  },

  {
    id: 13,
    image: CassidyMMA,
    value: "lifestyle",
  },

  {
    id: 14,
    image: ZenobiaP2,
    value: "boudoir",
  },

  {
    id: 15,
    image: Britt,
    value: "portraits",
  },

  {
    id: 16,
    image: Jasline,
    value: "portraits",
  },

  {
    id: 18,
    image: Karla,
    value: "portraits",
  },

  {
    id: 19,
    image: Lizz,
    value: "lifestyle",
  },

  {
    id: 20,
    image: GradStu,
    value: "lifestyle",
  },

  {
    id: 21,
    image: cesar,
    value: "streets",
  },
  {
    id: 22,
    image: DevonteP,
    value: "streets",
  },

  {
    id: 23,
    image: jordenMMA,
    value: "lifestyle",
  },

  {
    id: 24,
    image: jorden,
    value: "lifestyle",
  },
  {
    id: 25,
    image: nacier,
    value: "streets",
  },

  {
    id: 26,
    image: caston,
    value: "streets",
  },

  {
    id: 27,
    image: AnthonyPortrait,
    value: "portraits",
  },
  {
    id: 28,
    image: jerm,
    value: "streets",
  },
  {
    id: 29,
    image: raymond,
    value: "streets",
  },
  {
    id: 30,
    image: jordan,
    value: "streets",
  },
];

export const contacts = [
  {
    id: 1,
    icon: <LocationOnIcon />,
    text: "Brooklyn, New York, USA",
  },
  {
    id: 2,
    icon: <ContactMailIcon />,
    text: "DelvinReyes.95@gmail.com",
  },
];